<template>
  <metainfo>
    <template v-slot:title="{ content }">{{
      content ? `${content} | eGesparc` : `eGesparc`
    }}</template>
  </metainfo>
  <Suspense>
    <router-view :key="$route.fullPath" />
  </Suspense>
  <AuthLoginDialog />
  <div class="w-px hidden invisible">
    <Button class="hidden invisible"></Button>
    <InputText class="hidden invisible"></InputText>
    <!--
      `readonly` : ce bloc ne sert qu'a monter les composants pour leurs styles,
      mais le champ mot de passe qu'il contient est bien present dans le DOM de
      chaque page. Le gestionnaire de mots de passe de Chrome y voit un
      formulaire de connexion, cherche le champ identifiant le plus proche — le
      premier champ texte de la page, quel qu'il soit — et y ecrit l'adresse
      e-mail enregistree. Ni `autocomplete="off"` (Chrome l'ignore
      deliberement pour les identifiants) ni `type="search"` (qui n'ecarte que
      l'autofill adresses/paiement) n'y changeaient quoi que ce soit : c'est la
      presence du champ mot de passe qui declenche tout. Chrome ne remplit pas
      un champ en lecture seule, donc plus de formulaire de connexion a ses
      yeux. `inputProps` est necessaire : `Password` a `inheritAttrs: false` et
      poserait l'attribut sur son `div` racine, pas sur l'`input`.
    -->
    <Password
      class="hidden invisible"
      :input-props="{ readonly: true }"
    ></Password>
    <Divider class="hidden invisible"></Divider>
    <Card class="hidden invisible"></Card>
    <Drawer class="hidden invisible"></Drawer>
    <Toolbar class="hidden invisible"></Toolbar>
    <Editor class="hidden invisible"></Editor>
  </div>
</template>

<script lang="ts">
import { defineComponent, nextTick, onMounted } from "vue";
import { initializeComponents } from "@/core/plugins/keenthemes";
import Button from "primevue/button";
import Password from "primevue/password";
import InputText from "primevue/inputtext";
import Divider from "primevue/divider";
import Card from "primevue/card";
import Drawer from "primevue/drawer";
import Toolbar from "primevue/toolbar";
import AuthLoginDialog from "@/components/auth/AuthLoginDialog.vue";

export default defineComponent({
  name: "app",
  components: {
    AuthLoginDialog,
    Divider,
    InputText,
    Password,
    Button,
    Card,
    Drawer,
  },
  setup() {
    onMounted(() => {
      nextTick(() => {
        initializeComponents();
      });
    });
  },
});
</script>

<style lang="scss">
@import "~bootstrap-icons/font/bootstrap-icons.css";
@import "~quill/dist/quill.snow.css";
@import "~animate.css";
@import "~sweetalert2/dist/sweetalert2.css";
@import "~nouislider/distribute/nouislider.css";
@import "~@fortawesome/fontawesome-free/css/all.min.css";
@import "~socicon/css/socicon.css";
@import "~line-awesome/dist/line-awesome/css/line-awesome.css";
@import "~dropzone/dist/dropzone.css";
@import "~@vueform/multiselect/themes/default.css";
@import "~prism-themes/themes/prism-shades-of-purple.css";
// Main demo style scss
@import "assets/sass/plugins";
@import "assets/sass/style";
</style>
